import AccountingSystem from "./AccountingSystem";
class ArchiveFile {
	allFiles?: ArchiveFile[];
	yearFiles?: ArchiveFile[];
	one?: ArchiveFile;
	name: string = "";
	eng: string = "";
	checked: boolean = false;
	isMonth: boolean = false;
	noPdf?: boolean = false;
	isYear?: boolean = false;
	// tslint:disable-next-line:max-func-body-length
	constructor(system: AccountingSystem, name?: string, eng?: string) {
		if (system === AccountingSystem.npo) {
			this.allFiles = [
				{
					name: "辅助核算明细账",
					eng: "subsidiaryledger/dim/all",
					checked: false,
					isMonth: false
				},
				{
					name: "辅助核算余额表",
					eng: "balance/dim/all",
					checked: false,
					isMonth: false
				},
				{
					name: "资产负债表",
					eng: "balancesheet",
					checked: false,
					isMonth: false
				},
				{
					name: "现金流量表",
					eng: "cashflow",
					checked: false,
					isMonth: false
				},
				{
					name: "余额表",
					eng: "balance",
					checked: false,
					isMonth: false
				},
				{
					name: "明细账",
					eng: "subsidiaryledger/all",
					checked: false,
					isMonth: false
				},
				{
					name: "数量明细账",
					eng: "subsidiaryledger/num/all",
					checked: false,
					isMonth: false
				},
				{
					name: "外币明细账",
					eng: "subsidiaryledger/curr/all",
					checked: false,
					isMonth: false
				},
				{
					name: "数量外币明细账",
					eng: "subsidiaryledger/numcurr/all",
					checked: false,
					isMonth: false
				},
				{
					name: "业务活动表",
					eng: "activity",
					checked: false,
					isMonth: false
				},
				{
					name: "业务活动表季报",
					eng: "activity/qua",
					checked: false,
					isMonth: false
				},
				{
					name: "数量余额表",
					eng: "balance/num",
					checked: false,
					isMonth: false
				},
				{
					name: "外币余额表",
					eng: "balance/curr",
					checked: false,
					isMonth: false
				},
				{
					name: "数量外币余额表",
					eng: "balance/numcurr",
					checked: false,
					isMonth: false
				},
				{
					name: "固定资产",
					noPdf: true,
					eng: "fixedassets",
					checked: false,
					isMonth: false
				},
				{
					name: "无形资产",
					noPdf: true,
					eng: "fixedassets2",
					checked: false,
					isMonth: false
				},
				{
					name: "长期待摊费用",
					noPdf: true,
					eng: "fixedassets3",
					checked: false,
					isMonth: false
				},
				{
					name: "凭证",
					eng: "vouchereasy",
					checked: false,
					isMonth: false,
					// noPdf: true
				},
				{
					name: "存货数量辅助核算明细账",
					eng: "subsidiaryledger/dim/num/all",
					checked: false,
					isMonth: false
				},
			];
		} else if (system === AccountingSystem.rural) {
			this.allFiles = [
				{
					name: "辅助核算明细账",
					eng: "subsidiaryledger/dim/all",
					checked: false,
					isMonth: false
				},
				{
					name: "辅助核算余额表",
					eng: "balance/dim/all",
					checked: false,
					isMonth: false
				},
				{
					name: "资产负债表",
					eng: "balancesheet",
					checked: false,
					isMonth: false
				},
				{
					name: "余额表",
					eng: "balance",
					checked: false,
					isMonth: false
				},
				{
					name: "明细账",
					eng: "subsidiaryledger/all",
					checked: false,
					isMonth: false
				},
				{
					name: "数量明细账",
					eng: "subsidiaryledger/num/all",
					checked: false,
					isMonth: false
				},
				{
					name: "外币明细账",
					eng: "subsidiaryledger/curr/all",
					checked: false,
					isMonth: false
				},
				{
					name: "数量外币明细账",
					eng: "subsidiaryledger/numcurr/all",
					checked: false,
					isMonth: false
				},
				{
					name: "收益分配表",
					eng: "income/distribution",
					checked: false,
					isMonth: false
				},
				{
					name: "数量余额表",
					eng: "balance/num",
					checked: false,
					isMonth: false
				},
				{
					name: "外币余额表",
					eng: "balance/curr",
					checked: false,
					isMonth: false
				},
				{
					name: "数量外币余额表",
					eng: "balance/numcurr",
					checked: false,
					isMonth: false
				},
				{
					name: "固定资产",
					noPdf: true,
					eng: "fixedassets",
					checked: false,
					isMonth: false
				},
				{
					name: "凭证",
					eng: "vouchereasy",
					checked: false,
					isMonth: false,
					// noPdf: true
				},
				{
					name: "存货数量辅助核算明细账",
					eng: "subsidiaryledger/dim/num/all",
					checked: false,
					isMonth: false
				},
			];
		} else {
			this.allFiles = [
				{
					name: "辅助核算明细账",
					eng: "subsidiaryledger/dim/all",
					checked: false,
					isMonth: false
				},
				{
					name: "辅助核算余额表",
					eng: "balance/dim/all",
					checked: false,
					isMonth: false
				},
				{
					name: "资产负债表",
					eng: "balancesheet",
					checked: false,
					isMonth: false
				},
				{
					name: "利润表",
					eng: "income",
					checked: false,
					isMonth: false
				},
				{
					name: "现金流量表",
					eng: "cashflow",
					checked: false,
					isMonth: false
				},
				{
					name: "余额表",
					eng: "balance",
					checked: false,
					isMonth: false
				},
				{
					name: "明细账",
					eng: "subsidiaryledger/all",
					checked: false,
					isMonth: false
				},
				{
					name: "数量明细账",
					eng: "subsidiaryledger/num/all",
					checked: false,
					isMonth: false
				},
				{
					name: "外币明细账",
					eng: "subsidiaryledger/curr/all",
					checked: false,
					isMonth: false
				},
				{
					name: "数量外币明细账",
					eng: "subsidiaryledger/numcurr/all",
					checked: false,
					isMonth: false
				},
				{
					name: "数量余额表",
					eng: "balance/num",
					checked: false,
					isMonth: false
				},
				{
					name: "外币余额表",
					eng: "balance/curr",
					checked: false,
					isMonth: false
				},
				{
					name: "数量外币余额表",
					eng: "balance/numcurr",
					checked: false,
					isMonth: false
				},
				{
					name: "固定资产",
					noPdf: true,
					eng: "fixedassets",
					checked: false,
					isMonth: false
				},
				{
					name: "无形资产",
					noPdf: true,
					eng: "fixedassets2",
					checked: false,
					isMonth: false
				},
				{
					name: "长期待摊费用",
					noPdf: true,
					eng: "fixedassets3",
					checked: false,
					isMonth: false
				},
				{
					name: "凭证",
					eng: "vouchereasy",
					checked: false,
					isMonth: false,
					// noPdf: true
				},
				{
					name: "季度利润表",
					eng: "income/qua",
					checked: false,
					isMonth: false
				},
				{
					name: "存货数量辅助核算明细账",
					eng: "subsidiaryledger/dim/num/all",
					checked: false,
					isMonth: false
				},
			];
		}

		this.one = {
			name: <string>name,
			eng: <string>eng,
			checked: false,
			isMonth: true
		};
		this.yearFiles = [
			{
				name: "明细账",
				eng: "subsidiaryledger/all",
				checked: false,
				isMonth: false
			},
			{
				name: "数量明细账",
				eng: "subsidiaryledger/num/all",
				checked: false,
				isMonth: false
			},
			{
				name: "外币明细账",
				eng: "subsidiaryledger/curr/all",
				checked: false,
				isMonth: false
			},
			{
				name: "数量外币明细账",
				eng: "subsidiaryledger/numcurr/all",
				checked: false,
				isMonth: false
			},
			{
				name: "辅助核算明细账",
				eng: "subsidiaryledger/dim/all",
				checked: false,
				isMonth: false
			},
			{
				name: "辅助核算余额表",
				eng: "balance/dim/all",
				checked: false,
				isMonth: false
			},
			{
				name: "数量余额表",
				eng: "balance/num",
				checked: false,
				isMonth: false
			},
			{
				name: "外币余额表",
				eng: "balance/curr",
				checked: false,
				isMonth: false
			},
			{
				name: "数量外币余额表",
				eng: "balance/numcurr",
				checked: false,
				isMonth: false
			},
			{
				name: "总账",
				eng: "generalledger/all",
				checked: false,
				isMonth: false
			},
			{
				name: "余额表",
				eng: "balance",
				checked: false,
				isMonth: false
			},
			{
				name: "凭证",
				eng: "vouchereasy",
				checked: false,
				isMonth: false,
				isYear: true,
				// noPdf: true
			}
		];
	}
}

export default ArchiveFile;
